import apiSlice from '../api/api.slice';
import { AchievementDefinition, UserAchievements } from './achievement.types';

const achievementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAchievementCatalog: builder.query<AchievementDefinition[], void>({
      query: () => ({ url: '/api/v1/achievement/catalog', method: 'GET' }),
      transformResponse: (response: {
        achievements: AchievementDefinition[];
      }) => response.achievements,
    }),
    getUserAchievements: builder.query<UserAchievements, string>({
      query: (username) => ({
        url: `/api/v1/achievement/users/${encodeURIComponent(username)}`,
        method: 'GET',
      }),
      transformResponse: (response: UserAchievements) => ({
        totalPoints: response.totalPoints,
        earned: response.earned,
      }),
      // the owner's fetch is what grants new achievements and their coins
      async onQueryStarted(_username, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(apiSlice.util.invalidateTags(['Points']));
        } catch {
          // a failed fetch granted nothing, so there is nothing to refresh
        }
      },
    }),
  }),
});

export const { useGetAchievementCatalogQuery, useGetUserAchievementsQuery } =
  achievementApiSlice;
